// Require an explicit timezone: never guess whether a legacy wall-clock string
// means UTC or local time. Validate components before Date can normalize them.
export function parseMessageTime(value) {
  if (typeof value !== 'string') return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,9}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
  if (!match) return null;
  const [, year, month, day, hour, minute, second, , zone] = match;
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  const leap = y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (y === 0 || m < 1 || m > 12 || d < 1 || d > days[m - 1] ||
      Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return null;
  // RFC 3339's -00:00 means an unknown local offset.
  if (zone === '-00:00' || (zone !== 'Z' &&
      (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4)) > 59))) return null;
  const instant = Date.parse(value);
  return Number.isFinite(instant) ? instant : null;
}

export function compareMessageTimes(a, b) {
  const left = parseMessageTime(a);
  const right = parseMessageTime(b);
  // Unknown instants go last, retaining their original order.
  if (left === null) return right === null ? 0 : 1;
  if (right === null) return -1;
  return left - right;
}

export function formatMessageTime(value, { now = new Date(), timeZone } = {}) {
  const instant = parseMessageTime(value);
  if (instant === null) {
    return { label: 'Time unavailable', full: 'Time unavailable: missing, invalid, or unspecified timezone.', dateTime: undefined };
  }
  // Leaving timeZone undefined uses the dispatcher's browser timezone.
  const zone = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(instant);
  const calendar = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, year: 'numeric', month: 'short', day: 'numeric',
  });
  const clock = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, hour: 'numeric', minute: '2-digit', hour12: true,
  }).format(date);
  const localDate = calendar.format(date);
  const full = new Intl.DateTimeFormat('en-US', {
    timeZone: zone, year: 'numeric', month: 'long', day: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit',
    hour12: true, timeZoneName: 'long',
  }).format(date);
  return {
    label: localDate === calendar.format(now) ? clock : `${localDate}, ${clock}`,
    full: `${full} (${zone})`,
    dateTime: date.toISOString(),
  };
}
